import { FC } from 'react';

interface AvatarI {
    name: string;
}

const Avatar: FC<AvatarI> = ({ name }) => {
    const n = name.split(' ');
    const initials = `${n[0].charAt(0)}${n[1]?.charAt(0) ?? ''}`;
    return (
        <div
            className={`h-8 w-8 rounded-full flex flex-shrink-0 items-center 
    justify-center bg-gray-100 text-surface-medium font-poppins 
    font-semibold`}
        >
            {initials}
        </div>
    );
};

export default Avatar;
